import * as React from "react";

import { cn } from "@/lib/utils/cn";

export interface TextareaProps extends React.ComponentProps<"textarea"> {
  /**
   * Character count object. If provided, a character counter will be displayed below the textarea.
   */
  count?: {
    current: number;
    max: number;
  };
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, count, rows = 6, ...props }, ref) => {
    return (
      <div className="space-y-2 w-full">
        <textarea
          ref={ref}
          rows={rows}
          data-slot="textarea"
          className={cn(
            "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground bg-input border-border hover:border-neutral-400 dark:bg-foreground/10 dark:hover:border-neutral-500 flex min-h-[60px] w-full rounded-lg border px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
            "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
            className
          )}
          {...props}
        />
        {count !== undefined && count.max !== undefined && (
          <div className="flex justify-end">
            <span className="text-muted-foreground text-xs">
              {count.current}/{count.max}
            </span>
          </div>
        )}
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
